import { createContext } from "react";
var initialContextValue = {
    lps: [],
    dsps: [],
    authorizedLps: {},
    isFetchAuthorizedLogisticProvidersLoading: false,
    isFetchLogisticProvidersLoading: false
};
var LPContext = createContext(initialContextValue);
export default LPContext;

//# sourceMappingURL=LPContext.js.map